import { Group } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { FaultRow } from 'components/tables/data/fault/types';
import P2Regular from 'components/typography/P2Regular';

/** Operator who recorded the resolution. */
export default function RecordedByNameColumn({ data: { fixed } }: { data: FaultRow }) {
  if (!fixed?.recordedBy?.userId) return null;

  return (
    <Group spacing={8} noWrap>
      <IconUser stroke={1.5} size={24} />
      <P2Regular color="gray.8" lineClamp={3}>
        {fixed.recordedBy.fullName}
      </P2Regular>
    </Group>
  );
}
